(function(){
    document.addEventListener("DOMContentLoaded", function() {
        // Add click event listener to each tab button
        let collections_with_tab = [...document.querySelectorAll(".collections-with-tab")];
        collections_with_tab.forEach(collection_tab_section => {
            collection_tab_section.querySelectorAll(".tab-btns .button").forEach(tab_btn => {
                tab_btn.addEventListener("click", function() {
                    let target = tab_btn.getAttribute("data-target");
                    let data_url = tab_btn.getAttribute("data-url");
                    let data_text = tab_btn.getAttribute("data-link-text");

                    // Change the link text
                    collection_tab_section.querySelector(".section-header a .reversed-link").innerHTML = data_text;
                    collection_tab_section.querySelector(".section-header a").setAttribute("href", data_url);

                    // Remove 'active' class from all tab content and buttons
                    document.querySelectorAll(".tab-content").forEach(tab_content => {
                        tab_content.classList.remove("active");
                    });
                    document.querySelectorAll(".tab-btns .button").forEach(btn => {
                        btn.classList.remove("active");
                    });

                    // Add 'active' class to the clicked button and its corresponding tab content
                    tab_btn.classList.add("active");
                    document.querySelector(".tab-content." + target).classList.add("active");

                    // Center the active button if it's scrollable
                    const tabBtns = collection_tab_section.querySelector(".tab-btns");
                    const activeBtn = tab_btn;

                    // Scroll the button into view, centered within the container
                    const btnOffsetLeft = activeBtn.offsetLeft;
                    const btnWidth = activeBtn.offsetWidth;
                    const containerWidth = tabBtns.offsetWidth;

                    // Calculate the scroll position to center the button
                    const scrollLeft = btnOffsetLeft - (containerWidth / 2) + (btnWidth / 2);

                    // Scroll to the calculated position
                    tabBtns.scrollTo({
                        left: scrollLeft,
                        behavior: 'smooth' // You can change to 'auto' for an instant scroll
                    });
                });
            });
        });
        document.body.setAttribute("collection-layout","multi");
        $("body").on("click","[data-collection-layout-toggle]", function() {
            var layout = $(this).attr("data-collection-layout-toggle");
            $("body").attr("collection-layout", layout);
        });
    });
})();
